import { render } from "./RadioTabletFormComponentDetails.vue?vue&type=template&id=46139d8c"
import script from "./RadioTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./RadioTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__